export default __webpack_public_path__ + "static/media/fortmatic.cae62a4d.svg";